import qs from 'qs';

import GET_FC_KEY from './graphql/getFcKeyGql';

export interface IChatGPTConfig {
  defaultQuestion: string;
  auto: boolean;
}
export const ChatGPTUrl = 'https://leyoyu.cn/';

export async function getChatGPTIframeUrl(config?: IChatGPTConfig) {
  let query = '';
  let fcKey;

  try {
    const res = await window.$getClemanClient().apollo.query({
      query: GET_FC_KEY
    });

    if (res.data?.currentUser?.sandbox?.aiFcKey) {
      fcKey = res.data.currentUser.sandbox.aiFcKey;
    }
  } catch (error) {
    console.log('获取fcKey失败', error);
  }

  const queryData = qs.stringify({
    q: config?.defaultQuestion,
    as: config?.auto,
    ht: true, // 用于让内嵌的ChatGPT识别是否是课灵内嵌
    fcKey
  });

  if (queryData) {
    query = '?' + queryData;
  }

  return ChatGPTUrl + query;
}
